module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Mail-notification-a4d253d38665a756cd8ee8534d24a0ec.svg";